import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import ClassAssembly2024 from '../ClassAssembly2024';
import Archive2022 from '../ClassAssembly2023/Archive2022';

const ClassAssembly9D2024 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url}/home/events-activities/class-assembly/9D/1.webp`;
    const p2 = `${config.base_image_url}/home/events-activities/class-assembly/9D/2.webp`;
    const p3 = `${config.base_image_url}/home/events-activities/class-assembly/9D/3.webp`;
    const p4 = `${config.base_image_url}/home/events-activities/class-assembly/9D/4.webp`;
    const p5 = `${config.base_image_url}/home/events-activities/class-assembly/9D/5.webp`;
    const p6 = `${config.base_image_url}/home/events-activities/class-assembly/9D/6.webp`;
    const p7 = `${config.base_image_url}/home/events-activities/class-assembly/9D/7.webp`;
    const p8 = `${config.base_image_url}/home/events-activities/class-assembly/9D/8.webp`;
    const p9 = `${config.base_image_url}/home/events-activities/class-assembly/9D/9.webp`;
    const p10 = `${config.base_image_url}/home/events-activities/class-assembly/9D/10.webp`;
    const p11 = `${config.base_image_url}/home/events-activities/class-assembly/9D/11.webp`;
    const p12 = `${config.base_image_url}/home/events-activities/class-assembly/9D/12.webp`;
    const p13 = `${config.base_image_url}/home/events-activities/class-assembly/9D/13.webp`;
    const p14 = `${config.base_image_url}/home/events-activities/class-assembly/9D/14.webp`;
    const p15 = `${config.base_image_url}/home/events-activities/class-assembly/9D/15.webp`;
    const p16 = `${config.base_image_url}/home/events-activities/class-assembly/9D/16.webp`;
    const p17 = `${config.base_image_url}/home/events-activities/class-assembly/9D/17.webp`;
    const p18 = `${config.base_image_url}/home/events-activities/class-assembly/9D/18.webp`;
    const p19 = `${config.base_image_url}/home/events-activities/class-assembly/9D/19.webp`;
    const p20 = `${config.base_image_url}/home/events-activities/class-assembly/9D/20.webp`;
    const p21 = `${config.base_image_url}/home/events-activities/class-assembly/9D/21.webp`;
    const p22 = `${config.base_image_url}/home/events-activities/class-assembly/9D/22.webp`;
    const p23 = `${config.base_image_url}/home/events-activities/class-assembly/9D/23.webp`;
    const p24 = `${config.base_image_url}/home/events-activities/class-assembly/9D/24.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },

        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },

        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        },
        {
            src: p10,
            source: p10,
            rows: 1,
            cols: 1,
        },
        {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
        },
        {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
        },
        {
            src: p13,
            source: p13,
            rows: 1,
            cols: 1,
        },
        {
            src: p14,
            source: p14,
            rows: 1,
            cols: 1,
        },
        {
            src: p15,
            source: p15,
            rows: 1,
            cols: 1,
        },
        {
            src: p16,
            source: p16,
            rows: 1,
            cols: 1,
        },
        {
            src: p17,
            source: p17,
            rows: 1,
            cols: 1,
        },
        {
            src: p18,
            source: p18,
            rows: 1,
            cols: 1,
        },
        {
            src: p19,
            source: p19,
            rows: 1,
            cols: 1,
        },
        {
            src: p20,
            source: p20,
            rows: 1,
            cols: 1,
        },
        {
            src: p21,
            source: p21,
            rows: 1,
            cols: 1,
        },
        {
            src: p22,
            source: p22,
            rows: 1,
            cols: 1,
        },
        {
            src: p23,
            source: p23,
            rows: 1,
            cols: 1,
        },
        {
            src: p24,
            source: p24,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    Empathy -The Key to Heal the World
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 9 D   Date: 2,3 & 4 December 2024
                                </Typography>
                                {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “We all have dreams. But in order to make dreams come into reality, it takes tremendous
    determination, dedication, self-discipline and effort.”

<br/>
        </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    The students of class 9D presented an inspiring assembly on the theme ‘Empathy -The Key to Heal the World’. The assembly commenced with a powerful and meaningful thought for the day.
                                    <br></br>
                                    A self-composed poignant poem titled ‘Walk in their Shoes’ was recited, capturing the essence of understanding the other’s struggles.
                                    <br></br>
                                    A street play on the topic depicted how small acts of kindness can alleviate the suffering of differently abled people.
                                    <br></br>
                                    This was followed by a soulful rendition of Michael Jackson’s iconic song ‘Heal The World’. The assembly left an indelible mark, highlighting the significance of empathy in our daily lives.
                                    <br></br>
                                    As Mahatma Gandhi aptly said, “The best way to find yourself is to lose yourself in the service of others.” The assembly beautifully illustrated how small act of kindness can foster a more compassionate and empathetic community.
                                    <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            >It is not our differences that divide us. It is our inability to recognize, accept, and celebrate those differences.
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <ClassAssembly2024 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>
                        {/* <SidebarNewsletter /> */}
                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ClassAssembly9D2024